import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Prompt, useHistory } from 'react-router-dom';

import { useSelector } from 'store';
import { Title } from 'shared';
import { useTranslation } from 'hooks/useTranslation';
import { BulkUploadTopSection } from 'features/dashboard/components/BulkUploadTopSection';
import { BulkUploadSection } from 'features/dashboard/components/BulkUploadSection';
import { clearOrdersState } from 'features/dashboard/redux/actions';
import { SuccessfulAction } from 'features/dashboard/components/SuccessfulAction';
import { ProcessBulkOrder } from 'features/dashboard/components/ProcessBulkOrder';
import { ReactComponent as PlaneIcon } from 'assets/icons/plane-icon.svg';

const SendGiftInBulk = () => {
  const { listen } = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isBulkUploaded, isBulkOrderProcessing, isLoading } = useSelector(state => state.dashboard.orders);
  const [selectedFileName, setSelectedFileName] = useState('');

  const handleFileSelect = (fileName: string) => setSelectedFileName(fileName);

  useEffect(() => {
    const unlisten = listen(() => {
      dispatch(clearOrdersState());
    });

    return () => unlisten();
  }, [dispatch, listen]);

  const handleOrderCreated = useCallback(() => {
    dispatch(clearOrdersState());
  }, [dispatch]);

  return (
    <>
      <Prompt when={isBulkUploaded && !isBulkOrderProcessing} message={t('formLeavingPrompt', { ns: 'common' })} />
      <Title title={t('sendRewardsInBulk', { ns: 'dashboard' })} />
      <>
        {!isBulkUploaded && !isBulkOrderProcessing && (
          <>
            <BulkUploadTopSection />
            <BulkUploadSection onSelectFile={handleFileSelect} />
          </>
        )}
        {isBulkOrderProcessing && (
          <SuccessfulAction variant="bulk" onSuccessfulAction={handleOrderCreated} icon={PlaneIcon} />
        )}
        {!isLoading && isBulkUploaded && !isBulkOrderProcessing && (
          <ProcessBulkOrder selectedFileName={selectedFileName} />
        )}
      </>
    </>
  );
};

export default SendGiftInBulk;
